/**
 * A silhouette per vehicle type, for the swatch in the corner of a fleet
 * card. Falls back to the dump-truck shape for any type not listed here
 * rather than rendering nothing — a missing icon is a much smaller problem
 * than a blank tile where the card's one piece of at-a-glance identity
 * should be.
 */
const PATHS = {
  dump_truck: (
    <>
      <path d="M2 16h1V8a1 1 0 0 1 1-1h8v9" />
      <path d="M12 8h4.3a1 1 0 0 1 .8.4l2.5 3.3a1 1 0 0 1 .2.6V16h1" />
      <path d="M4 8l1.6-3h3.9" />
      <circle cx="7" cy="17.4" r="1.7" />
      <circle cx="16.5" cy="17.4" r="1.7" />
    </>
  ),
  semi_trailer: (
    <>
      <path d="M2 15V9a1 1 0 0 1 1-1h11v7" />
      <path d="M14 12h4.3a1 1 0 0 1 .8.4l1.6 2.1a1 1 0 0 1 .3.6V15h1" />
      <circle cx="6" cy="16.6" r="1.6" />
      <circle cx="10.6" cy="16.6" r="1.6" />
      <circle cx="18" cy="16.6" r="1.6" />
    </>
  ),
  tractor_unit: (
    <>
      <path d="M3 15V9.5a1 1 0 0 1 1-1h5.2L13.5 12v3" />
      <path d="M13.5 12h3.4a1 1 0 0 1 .8.4l1.6 2a1 1 0 0 1 .3.6v1" />
      <circle cx="6.4" cy="16.6" r="1.6" />
      <circle cx="15.4" cy="16.6" r="1.6" />
    </>
  ),
  tuktuk_scooter: (
    <>
      <circle cx="6" cy="17" r="1.8" />
      <circle cx="17" cy="17" r="1.8" />
      <path d="M6 17h4l2.4-7H15" />
      <path d="M10.6 10h3.6" />
      <path d="M15.4 17h1.6" />
    </>
  ),
};

export function VehicleTypeIcon({ type, className = '' }) {
  return (
    <svg
      viewBox="0 0 22 20"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {PATHS[type] ?? PATHS.dump_truck}
    </svg>
  );
}
